/**
 * Deep K: three silos of boulders, each held up by a door. The gold silo pours onto a magic wall,
 * the jade silo crushes a butterfly, the ruby silo empties diamonds into a trough where its own
 * key lies (docs/spec/03 §3).
 */

import type { CaveDef } from '../types';

export const deepK: CaveDef = {
  id: 'K',
  name: 'KEYSTONE',
  hint: 'Each key lets a silo fall. Know where it will land.',
  intermission: false,
  colors: [11, 10, 7],
  diamondValue: 24,
  extraValue: 42,
  magicWallTime: 10,
  fill: { base: '.', items: [['r', 12], ['d', 4]] },
  levels: [
    { seed: 6101, diamonds: 20, time: 150 },
    { seed: 6102, diamonds: 22, time: 140 },
    { seed: 6103, diamonds: 24, time: 130 },
    { seed: 6104, diamonds: 26, time: 120 },
    { seed: 6105, diamonds: 28, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...???wrw?????????wrw?????????wdw?????W',
    'W.P....wrw?????????wrw?????????wdw?????W',
    'W......wrw?????????wrw?????????wrw?????W',
    'W...1..wrw?????????wrw?????????wdw?????W',
    'W??????wrw?????????wrw?????????wdw?????W',
    'W??????wrw?????????wrw?????????wdw?????W',
    'W??????wrw?????????wrw?????????wrw?????W',
    'W??????wrw?????????wrw?????????wdw?????W',
    'W??????w4w?????????w5w?????????w6w?????W',
    'W??????w w?????????w w?????????w w?????W',
    'W????wwwmwww???????wbw????wwwwww wwww??W',
    'W????w     w???????www????w         w??W',
    'W????w     w???????????....     3   w??W',
    'W????w     ..?????????????wwwwwwwwwww??W',
    'W????wwwwwww???????????????????????????W',
    'W?????????????????????????.2.??????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W?????????????????????????????????.....W',
    'W?????????????????????????????????...X.W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
